module.exports = __webpack_public_path__ + "img/normal_icon_07.098cc6b.png";